module.exports = "/assets/data/d46068df0fe7aca05662920a8687f7cc-NE3.data.json";